//
import { Component } from "react"
import { connect } from "react-redux"
import PropTypes from "prop-types"
import { fromJS } from "immutable"

import genericFilterGroup from "shared/search/containers/FilterGroup/FilterGroups"

import { selectCustomFields } from "shared/customFields/selectors"
import { loadCustomFields } from "shared/customFields/action-creators"

import { parseAndGenerateCustomFilters } from "shared/search/components/FilterableListView/helperFunctions"

export const createCustomFilterGroup = (uniqueFilterGroupId, customDataType, additionalFilters = []) => {
    const mapStateToProps = (state, props) => ({
        customTags: selectCustomFields(customDataType)(state),
    })
    const actions = {
        loadCustomFields,
    }

    class UnconnectedCustomFilterGroup extends Component {
        shouldComponentUpdate(nextProps) {
            return (
                !fromJS(nextProps.customTags).equals(fromJS(this.props.customTags)) ||
                nextProps.searchFilterTerm !== this.props.searchFilterTerm
            )
        }

        render() {
            // I believe we call parseAndGenerate twice (here and in helperFunctions), because this call is to render the control
            // And the other call is to generate the Redux connections
            const customTagFilters = parseAndGenerateCustomFilters(this.props.customTags, this.props.customDataType)

            let allFilters = customTagFilters
            if (this.props.additionalFilters.length) {
                allFilters = this.props.additionalFilters.concat(customTagFilters)
            }

            return genericFilterGroup({
                uniqueFilterGroupId,
                additionalFilters,
                filters: allFilters,
                displayLabel: Userdata.has_international_region
                    ? `Custom Fields (${DjangIO.app.models.QuorumDataType.by_value(customDataType).plural})`
                    : "Custom Fields",
                helpText: "Filter results by a custom characteristic saved to them.",
                ...this.props,
            })
        }
    }

    UnconnectedCustomFilterGroup.propTypes = {
        additionalFilters: PropTypes.array,
        customDataType: PropTypes.number.isRequired,
        customTags: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
        loadCustomFields: PropTypes.func.isRequired,
        // selected from the search => props.uniqueFlvId slice of the store
        searchFilterTerm: PropTypes.string,
        uniqueFilterGroupId: PropTypes.string.isRequired,
        uniqueFlvId: PropTypes.string.isRequired,
    }

    const connectedFilterGroup = connect(mapStateToProps, actions)(UnconnectedCustomFilterGroup)
    Object.assign(connectedFilterGroup, {
        defaultProps: {
            uniqueFilterGroupId,
            customDataType,
            additionalFilters,
        },
    })

    return connectedFilterGroup
}
